import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Slide } from '../models/slide';

@Injectable({
  providedIn: 'root'
})
export class SlidesService {

  constructor(
    private _http:HttpClient
  )
  {}

  public getSlides():Observable<any>
  {
    return this._http.get<Slide[]>(environment.apiEndpoint + `/api/admin/slides`).pipe(
      map(res => {
          return res;
      })
    );
  }

  public createSlide(slide:Slide):Observable<any>
  {
    return this._http.post(environment.apiEndpoint + '/api/admin/slides', {slide:slide}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public deleteSlide(id:number):Observable<any>
  {
    return this._http.delete(environment.apiEndpoint + `/api/admin/slides/${id}`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public moveUp(id:number):Observable<any>
  {
    return this._http.put(environment.apiEndpoint + `/api/admin/slides`, {direction: 'up', id: id}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public moveDown(id:number):Observable<any>
  {
    return this._http.put(environment.apiEndpoint + `/api/admin/slides`, {direction: 'down', id: id}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public setSlideStatus(status:boolean, id:number):Observable<any>
  {
    return this._http.put(environment.apiEndpoint + `/api/admin/slide/status`, {status:status, id:id}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
